export default [{
    path: "*",
    meta: {
      public: true
    },
    redirect: {
      path: "/404"
    }
  },
  {
    path: "/404",
    meta: {
      public: true
    },
    name: "NotFound",
    component: () => import("@/pages/NotFound.vue")
  },
  {
    path: "/403",
    meta: {
      public: true
    },
    name: "AccessDenied",
    component: () => import("@/pages/Deny.vue")
  },
  {
    path: "/500",
    meta: {
      public: true
    },
    name: "ServerError",
    component: () => import("@/pages/Error.vue")
  },
  {
    path: "/login",
    meta: {
      public: true
    },
    name: "Login",
    component: () => import("@/pages/Login.vue")
  },
  {
    path: "/register",
    meta: {
      public: true
    },
    name: "Register",
    component: () => import("@/pages/Register.vue")
  },
  {
    path: "/invite/:token",
    meta: {
      public: true
    },
    name: "Invite",
    component: () => import("@/pages/invite.vue")
  },
  {
    path: "/shop/create",
    meta: {
      public: true
    },
    name: "ShopCreate",
    component: () => import("@/pages/Shop.vue")
  },
  {
    path: "/forget/password",
    meta: {
      public: true
    },
    name: "ForgetPassword",
    component: () => import("@/pages/ForgetPassword.vue")
  },
  {
    path: "/verify/:token",
    meta: {
      public: true
    },
    name: "Verify",
    component: () => import("@/pages/verify.vue")
  },
  {
    path: "/resetpassword/:token",
    meta: {
      public: true
    },
    name: "Resetpassword",
    component: () => import("@/pages/Resetpassword.vue")
  },
  {
    path: "/user-manual",
    meta: {
      public: true
    },
    name: "UserManual",
    component: () => import("@/pages/UserManual.vue")
  },
  {
    path: "/wizardsetting",
    meta: {
      public: true
    },
    name: "WizardSetting",
    component: () => import("@/pages/WizardSetting.vue")
  },
  {
    path: "/PeviewPDF/:docno/:empcode",
    meta: {
      public: true
    },
    name: "PeviewPDF",
    component: () => import("@/pages/PeviewPDF.vue")
  },
  {
    path: "/PeviewPDFSingha/:docno/:empcode",
    meta: {
      public: true
    },
    name: "PeviewPDFSingha",
    component: () => import("@/pages/PeviewPDFSingha.vue")
  },

  {
    path: "/ContributionsPDF/:docno",
    meta: {
      public: true
    },
    name: "ContributionsPDF",
    component: () => import("@/pages/ContributionPDF.vue")
  },
  {
    path: "/WithholdingTaxFormPDF/:year/:branch",
    meta: {
      public: true
    },
    name: "WithholdingTaxFormPDF",
    component: () => import("@/pages/WithholdingTaxKorPDF.vue")
  },
  {
    path: "/WHTC/:year/:empcode/:branch",
    meta: {
      public: true
    },
    name: "WithholdingTaxCertificatePDF",
    component: () => import("@/pages/WithholdingTaxCertificatePDF.vue")
  },
  {
    path: "/WHTCALL/:year/:empcode/:branch",
    meta: {
      public: true
    },
    name: "WithholdingTaxCertificateAllPDF",
    component: () => import("@/pages/WithholdingTaxCertificateAllPDF.vue")
  },
  {
    path: "/WHT/:branch/:fromDate/:toDate",
    meta: {
      public: true
    },
    name: "WHT",
    component: () => import("@/pages/WHT.vue")
  },
  {
    path: "/Attach1Kor/:year/:branch",
    meta: {
      public: true
    },
    name: "Attach1Kor",
    component: () => import("@/pages/attach1_kor.vue")
  },
  {
    path: "/Attach1/:branch/:fromDate/:toDate",
    meta: {
      public: true
    },
    name: "Attach1",
    component: () => import("@/pages/attach1.vue")
  },

  // admin
  {
    path: "/",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "PageAdmin",
    redirect: {
      name: 'Dashboard'
    },
    component: () => import("@/pages/Page.vue"),
    children: [{
        path: "/dashboard",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          _is_admin: true,
        },
        name: "Dashboard",
        component: () => import("@/pages/Dashboard.vue")
      },
      {
        path: "/shopsetting",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          _is_admin: true
        },
        name: "ShopSetting",
        component: () => import("@/pages/ShopSetting.vue")
      },
      {
        path: "/profile",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          //  _is_admin:true
        },
        name: "profile",
        component: () => import("@/pages/profile.vue")
      },
      {
        path: "/employee/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "EmployeeList",
        component: () => import("@/pages/Employee/List.vue")
      },
      {
        path: "/employee/create",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "EmployeeCreate",
        component: () => import("@/pages/Employee/Create.vue")
      },
      {
        path: "/employee/edit",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "EmployeeEdit",
        component: () => import("@/pages/Employee/Edit.vue")
      },
      {
        path: "/employee/Inactive",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "Employeeinactive",
        component: () => import("@/pages/Employee/Inactive.vue")
      },
       {
        path: "/setleaveemp/List",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "SetemployeeleaveList",
        component: () => import("@/pages/SetLeaveEmp/List.vue")
      },
      {
        path: "/ImportFile/ImportFileIncome",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "ImportFileIncome",
        component: () => import("@/pages/import/ImportIncome.vue")
      },
      {
        path: "/ImportFile/ListExpensed",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "ExpensedDocList",
        //component: () => import("@/pages/Import/ImportExpensed.vue")
        component: () => import("@/pages/Expensed_Doc/List.vue")
      },
      {
        path: "/ImportFile/ImportFileExpensed",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "ImportFileExpensed",
        component: () => import("@/pages/import/ImportExpensed.vue")
      },
      {
        path: "/ImportFile/ImportFingerScan",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          //_is_admin:true
        },
        name: "ImportFingerScan",
        component: () => import("@/pages/import/ImportFingerScan.vue")
      },
      {
        path: "/expensed/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "ExpensedList",
        component: () => import("@/pages/Expensed/List.vue")
      },
      {
        path: "/ImportFile/ListIncome",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "IncomeDocList",
        component: () => import("@/pages/Income_Doc/List.vue")
      },
      {
        path: "/income/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "IncomeList",
        component: () => import("@/pages/Income/List.vue")
      },
      {
        path: "/checkinout/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "CheckInOutList",
        component: () => import("@/pages/CheckInOut/List.vue")
      },
      {
        path: "/takeleave/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "TakeLeaveList",
        component: () => import("@/pages/TakeLeave/List.vue")
      },
      {
        path: "/changeplan/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "ChangePlanList",
        component: () => import("@/pages/ChangePlan/List.vue")
      },
      {
        path: "/timecheck/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "TimeCheckList",
        component: () => import("@/pages/TimeCheckList/List.vue")
      },
      {
        path: "/workplanbyemp/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          //_is_admin:true
        },
        name: "WorkPlanByEMPList",
        component: () => import("@/pages/WorkPlanByEMP/List.vue")
      },
      {
        path: "/otplan/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "OTPlanList",
        component: () => import("@/pages/OTPlan/List.vue")
      },
      {
        path: "/resign/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "ReSignList",
        component: () => import("@/pages/ReSign/List.vue")
      },
      {
        path: "/changesalary/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "ChangeSalaryList",
        component: () => import("@/pages/ChangeSalary/List.vue")
      },
      {
        path: "/changeworkplan/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          //_is_admin:true
        },
        name: "ChangeWorkplanList",
        component: () => import("@/pages/ChangeWorkplan/List.vue")
      },
      {
        path: "/plancompany/detail",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          //_is_admin:true
        },
        name: "PlansCompany",
        component: () => import("@/pages/PlanCompany/Detail.vue")
      },
      {
        path: "/checkin/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          //_is_admin:true
        },
        name: "CheckInList",
        component: () => import("@/pages/CheckIn/List.vue")
      },
      {
        path: "/salarytable/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          //_is_admin:true
        },
        name: "SalaryTableList",
        component: () => import("@/pages/SalaryTable/List.vue")
      },
      {
        path: "/formbank/detail/:docno",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "FormBankDetail",
        component: () => import("@/pages/FormBank/Detail.vue")
      },
      {
        path: "/payrolldoc/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "PayRollDocumentList",
        component: () => import("@/pages/PayRollDoc/List.vue")
      },
      {
        path: "/payrolldoc/detail/:docno/:details",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "PayRollDocDetail",
        component: () => import("@/pages/PayRollDoc/Detail.vue")
      },

      {
        path: "/holiday/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "HolidayList",
        component: () => import("@/pages/Holiday/List.vue")
      },
      {
        path: "/holidayinyear/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          //_is_admin:true
        },
        name: "HolidayInYear",
        component: () => import("@/pages/HolidayInYear/HolidayInYear.vue")
      },
      {
        path: "/branch/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          //_is_admin:true
        },
        name: "BranchList",
        component: () => import("@/pages/Branch/List.vue")
      },
      {
        path: "/department/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "DepartmentList",
        component: () => import("@/pages/Department/List.vue")
      },
      {
        path: "/workplan/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "WorkPlanList",
        component: () => import("@/pages/WorkPlan/List.vue")
      },
      {
        path: "/Conditions/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "ConditionsList",
        component: () => import("@/pages/Conditions/List.vue")
      },
      {
        path: "/address/create",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "CompanyAddress",
        component: () => import("@/pages/CompanyAddress/Create.vue")
      },
      {
        path: "/setting/general/create",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "GeneralSetting",
        component: () => import("@/pages/GeneralSetting/Create.vue")
      },
      {
        path: "/tax/List",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "TaxSettingList",
        component: () => import("@/pages/TaxSetting/List.vue")
      },
      {
        path: "/tax/Create",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "TaxSetting",
        //component: () => import("@/pages/TaxSetting/Create.vue")
        component: () => import("@/pages/TaxSetting/FormDialog.vue")
      },
      {
        path: "/setting/decimal/create",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "DecimalSetting",
        component: () => import("@/pages/DecimalSetting/Create.vue")
      },
      {
        path: "/setting/device/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "DeviceSettingList",
        component: () => import("@/pages/DeviceSetting/List.vue")
      },
      {
        path: "/setting/mapping/device/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "MappingDeviceSettingList",
        component: () => import("@/pages/MappingDeviceSetting/List.vue")
      },
      {
        path: "/ImportMaster/ImportEmployee",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          //_is_admin:true
        },
        name: "ImportEmployee",
        component: () => import("@/pages/Import_master/Import_Employee.vue")
      },
      {
        path: "/ImportMaster/ImportHoliday",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "ImportHoliday",
        component: () => import("@/pages/Import_master/Import_Holiday.vue")
      },
      {
        path: "/ImportMaster/ImportBranch",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "ImportBranch",
        component: () => import("@/pages/Import_master/Import_Branch.vue")
      },
      {
        path: "/ImportMaster/ImportDepartment",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "ImportDepartment",
        component: () => import("@/pages/Import_master/Import_Department.vue")
      },
      {
        path: "/TimeAttendance/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "TimeAttendanceList",
        component: () => import("@/pages/TimeAttendance/List.vue")
      },
      {
        path: "/ImportFile/ImportTimeAttendance",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "ImportTimeAttendance",
        component: () => import("@/pages/import/ImportTimeAttendance.vue")
      },
      {
        path: "/GroupPermissions/List",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "GroupPermissionsList",
        component: () => import("@/pages/GroupPermissions/List.vue")
      },
      {
        path: "/IndividualPermissions/List",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "IndividualPermissionsList",
        component: () => import("@/pages/IndividualPermissions/List.vue")
      },
      {
        path: "/Cumulative/CumulativeIncome",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          // _is_admin:true
        },
        name: "CumulativeIncome",
        component: () => import("@/pages/CumulativeIncome/Cumulative_Income.vue")
      },
      {
        path: "/WithholdingTaxForm",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
        },
        name: "WithholdingTaxForm",
        component: () => import("@/pages/Report/WithholdingTaxKor.vue")
      },
      {
        path: "/SocialSecurityKor20",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
        },
        name: "SocialSecurityKor20",
        component: () => import("@/pages/Report/SocialSecurityKor20.vue")
      },
      {
        path: "/WithholdingTaxCertificate",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
        },
        name: "WithholdingTaxCertificate",
        component: () => import("@/pages/Report/WithholdingTaxCertificate.vue")
      },
      {
        path: "/PNDForm",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
        },
        name: "PNDForm",
        component: () => import("@/pages/Report/PNDForm.vue")
      },
      {
        path: "/balanceofleave",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
        // _is_admin:true
        },
        name: "BalanceOfLeave",
        component: () => import("@/pages/Report/BalanceOfLeave.vue")
      },
      {
        path: "/Commission/list",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
        // _is_admin:true
        },
        name: "CommissionList",
        component: () => import("@/pages/Commission/List.vue")
      },
    ]
  },
  // Employee
  {
    path: "/emp",
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: "PageEmployee",
    redirect: {
      name: 'DashboardEmployee'
    },
    component: () => import("@/pages/Page.vue"),
    children: [{
        path: "/dashboardemp",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          _is_admin: false
        },
        name: "DashboardEmployee",
        component: () => import("@/pages/DashboardEmp.vue")
      },
      {
        path: "/checksalary",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          _is_admin: false
        },
        name: "CheckSalary",
        component: () => import("@/pages/CheckSalary/detail.vue")
      },
      {
        path: "/emp/profile",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          _is_admin: false
        },
        name: "profileEmployee",
        component: () => import("@/pages/profileEmployee.vue")
      },
      {
        path: "/workplanemp",
        meta: {
          breadcrumb: true,
          requiresAuth: true,
          //_is_admin:true
        },
        name: "WorkPlanEmp",
        component: () => import("@/pages/WorkPlanEmp.vue")
      },

    ]
  },


];